import React, { Component } from 'react';
import { SchoolInformationActions } from '../../../../store';
import { connect } from 'react-redux';
import AddNewCalendar from './AddNewCalendar';
import differenceInMinutes from "date-fns/differenceInMinutes"
import addMinutes from "date-fns/addMinutes";
import lodashUtil from 'lodash';
import { toast } from 'react-toastify';
import { GradePickerComponent, gradePickerUtil } from '../../gradePicker'
import { getTimeTableSlots } from './WeeklyCalendarUtil'
import { MuiDialog, MuiDialogContent, MuiGrid } from '../../../ui';
import { duration } from '@material-ui/core/styles';
import WeeklyCalendarCard from './WeeklyCalendarCard';
import * as StringReplacer from '../../../../i18n/StringReplacer';
import * as WeeklyCalendarUtil from './WeeklyCalendarUtil'
import theme from '../../../../assests/theme'
import spinner from "../../../ui/icons/spinner.gif";
import { saveSchoolScheduleConstraintsConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';

class WeeklyCalendarContainer extends Component {
	constructor(props) {
		super(props)
		let weeklyCalendar = []
		if (!lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
			if (this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar != undefined && this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar.length > 0) {
				weeklyCalendar = JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar))
			}
		}
		let startTime = new Date(1970, 0, 1, 8, 30, 0, 0);
		let endTime = new Date(1970, 0, 1, 9, 30, 0, 0);
		//weeklyCalendar=weeklyCalenderUtil.populatePeriodTimeStrs(weeklyCalendar);
		this.state = {
			startTime: new Date(startTime),
			endTime: new Date(endTime),
			startTimeStr: this.getHourMinStr(startTime),
			endTimeStr: this.getHourMinStr(endTime),
			duration: 60,
			isGradeDropDownFlag: false,
			typeOfPeriod: '',
			showAddNewCalendar: true,
			showCalendarTable: false,
			radioButtonValue: 'period',
			durationNote: this.props.i18n.calendar.periodOrLunchDuration,
			repeatDays: ["1", "2", "3", "4", "5"],
			gradeDetailsInWeeklyCal: undefined,
			gradeDetailsInPeriod: undefined,
			calendar: {
				periodsDetails: []
			},
			gradeLevelsForCalendar: { gradeLevels: this.props.activeSchool.school_master.gradeLevels },
			calendarName: '',
			gradeLevelsForPeriods: {
				gradeLevels: this.props.activeSchool.school_master.gradeLevels,
				isAllChecked: true,
				indeterminate: false
			},
			periodsDetails: [],
			periodsDetail: {},
			totalPeriods: null,
			activeSchool: this.props.activeSchool,
			activeScheduleIndex: this.props.activeScheduleIndex,
			weeklyCalendar: weeklyCalendar,
			showCard: true,
			edit: false,
			editPeriod: false,
			index: null,
			showAlertMessage: false,
			toggleChange: true,
			previousStartTime: undefined,
			periodFilterGradeDetails: undefined,
			showGradeDropDownInPeriod: true,
			totalPeriods: 0,
			displayingString: "",
			startHourSlot: null,
			lastHourSlot: null
		}

	}


	// when end time is set duration is calculated
	calculateDuration = (date) => {
		let startTime = this.state.startTime
		let duration = differenceInMinutes(date, startTime);
		this.setState({ duration: duration });
	}

	// set the time changed to the respective time. start or end.
	handleTimeChange = (date, label) => {
		const i18n = this.props.i18n
		if (date == null) {
			toast(i18n.calendar.emptyTime);
		}
		else {
			if (date != "Invalid Date") {
				date = date.setFullYear(1970, 0, 1)
				date = new Date(date);
				if (label === "Start Time") {
					let endTime = addMinutes(date, this.state.duration);

					this.setState({
						startTime: date, endTime: endTime,
						startTimeStr: this.getHourMinStr(date), endTimeStr: this.getHourMinStr(endTime)
					});
				} else if (label === "End Time") {
					this.calculateDuration(date)
					this.setState({ endTime: date, endTimeStr: this.getHourMinStr(date) });
				}
			}
		}
	}

	//when duration is enterd it calculates the end time and sets it.
	handleDurationChange = (event) => {
		const i18n = this.props.i18n
		let duration = Number(event.target.value);
		if (duration === 0) {
			this.setState({
				duration: null, endTime: this.state.startTime,
				endTimeStr: this.getHourMinStr(this.state.startTime)
			});
		}
		else if (duration < 0) {
			toast(i18n.calendar.negativeDuration);
			this.setState({
				duration: 15, endTime: this.state.startTime,
				endTimeStr: this.getHourMinStr(this.state.startTime)
			});
		}
		else {
			let endTime = addMinutes(this.state.startTime, duration);
			this.setState({
				duration: duration, endTime: endTime,
				endTimeStr: this.getHourMinStr(endTime)
			});
		}
	}

	//checkbox for BREAK
	toggleCheckboxIsBreak = () => {
		this.setState({ isBreak: !this.state.isBreak });
	}

	//checkbox for LUNCH BREAK
	toggleCheckboxIsLunchBreak = () => {
		this.setState({ isLunchBreak: !this.state.isLunchBreak });
	}

	// gradPicker open and close
	toggleGradPicker = () => {
		this.setState({
			isGradeDropDownFlag: !this.state.isGradeDropDownFlag,
		});
	}

	toggleGradPickerWithACheck = () => {
		if (this.state.calendar.periodsDetails.length > 0) {
			this.setState({ showAlertMessage: true });
		} else {
			this.setState({ isGradeDropDownFlag: !this.state.isGradeDropDownFlag });
		}
	}

	toggleGradPickerForPeriodFiltering = () => {
		if (this.state.calendar.periodsDetails.length > 0) {
			this.setState({ showAlertMessage: true });
		} else {
			this.setState({ isGradeDropDownFlag: !this.state.isGradeDropDownFlag });
		}
	}

	//add new calendar
	addNewCalendar = () => {
		
		let calendarData = getTimeTableSlots(this.state.calendar)
		this.setState({
			showAddNewCalendar: true,
			showCard: false,
			cal: {
				periodsDetails: []
			},
			editPeriod: false,
			calendarData: calendarData,

		});

	}

	//WEEKLY CAL CANCEL
	weeklyCalCancel = () => {
		this.setState({
			showCalendarTable: false,
			editPeriod: false
		})
	}

	// RADIO BUTTON handle change
	handleChangeForRadioButton = (event) => {
		if (event.target.value != "period") {
			this.setState({ showGradeDropDownInPeriod: false });
		} else {
			this.setState({ showGradeDropDownInPeriod: true });
		}
		this.radioButtonNote(event.target.value);

		this.setState({ radioButtonValue: event.target.value });
	}

	//note for type of period selected
	radioButtonNote = (typeOfPeriod) => {
		const i18n = this.props.i18n
		if (typeOfPeriod === "period" || typeOfPeriod === "lunch") {
			this.setState({
				durationNote: i18n.calendar.periodOrLunchDuration
			})
		} else {
			this.setState({
				durationNote: i18n.calendar.breakDuration
			})
		}
	}
	//Selecting of days
	onClickOfDays = (event, newArrayOfRepeatDays) => {
		let repeatDays = [];
		newArrayOfRepeatDays.map(days => {
			repeatDays.push(days)
		})
		this.setState({ repeatDays: repeatDays });
	}

	//create new period
	onClickOfCreate = () => {
		const i18n = this.props.i18n
		let weeklyCal = this.state.edit === true ?
			this.state.cal
			:
			this.state.calendar

		if (weeklyCal.gradeDetails !== undefined) {
			this.setState({
				showCalendarTable: true,
			})
		}
		else {
			toast(i18n.calendar.selectGradeFirst)
		}

	}



	/*
	this method is to validate the grade details if a calendar already has this particular gradeDetail 
	then we should not allow the user to create a calendar with the same or even one grade repeating. 
	*/

	calendarGradeDetailsValidation = (newGradeDetails) => {
		const i18n = this.props.i18n
		let arrayCalendars = this.state.weeklyCalendar;
		let newCalGradeDetails = gradePickerUtil.convertingGradeDetailsToLowestFormat(newGradeDetails, this.props);
		let newCalGradeDetailsCount = newCalGradeDetails.length;
		/*
				if there are any calendars saved previously then check with that gradeDetails
		*/
		if (arrayCalendars.length > 0) {

			for (let l = 0; l < arrayCalendars.length; l++) {
				let gradeDetailsOfCalendar = arrayCalendars[l].gradeDetails


				/*
				 if ALL GRADES are true then do not let the user create any calendar
				  */
				if (gradeDetailsOfCalendar.allGrades === true || newGradeDetails.allGrades === true) {
					toast(i18n.calendar.repeatingOfGrade)
					return false;
				}
				/*  
					if all grades is false only then get the gradeString and compare it with the new calenader gradeDetails
				*/
				else {
					let savedCalGradeDetails = gradePickerUtil.convertingGradeDetailsToLowestFormat(gradeDetailsOfCalendar, this.props);
					let compareingGradeString = lodashUtil.difference(newCalGradeDetails, savedCalGradeDetails);
					if (compareingGradeString.length !== newCalGradeDetailsCount) {
						toast(i18n.calendar.gradeAlreadyPresent)
						return false;
					}
				}
			}

		}
		return true;
	}

	//GRADE PICKER from CALENDAR
	gradePickerSaveInCalendar = (gradeDetails) => {
		let gradeDetailsObj;
		let gradeDetailsValidationFlag = this.calendarGradeDetailsValidation(gradeDetails)
		// if the validation has no errors only then continue with the saving part
		if (gradeDetailsValidationFlag === true) {
			this.state.cal.gradeDetails = gradeDetails
			this.state.calendar.gradeDetails = gradeDetails
			gradeDetailsObj = gradePickerUtil.changingSubsetGradeDetail(gradeDetails, this.props);
			this.setState({
				gradeDetailsInWeeklyCal: gradeDetails,
				gradeDetailsInPeriod: gradeDetailsObj,
			});
		}
	};

	// Filtering the periods gradeDetails saving
	gradePickerSaveForPeriodFiltering = (gradeDetails) => {

		let calendar
		if (this.state.calendar.gradeDetails != undefined) {
			calendar = this.state.calendar
		} else {
			calendar = this.state.weeklyCalendar[0]
		}
		this.filteringPeriods(gradeDetails, calendar);
		this.setState({
			periodFilterGradeDetails: gradeDetails
		})
	}

	//GRADE PICKER from PERIOD
	gradePickerSaveInPeriods = (gradeDetails) => {
		this.setState({
			gradeDetailsInPeriod: gradeDetails
		});

		this.toggleGradPicker();
	};

	//CALENDAR TABLE CANCEL
	calendarTableCancel = async () => {
		// await this.setState({
		// 	showCard: true,
		// 	showAddNewCalendar: false,
		// 	calendar: {
		// 		periodsDetails: []
		// 	},
		// 	cal: {
		// 		periodsDetails: []
		// 	}
		// })
		window.location.href='/'
	}

	saveEditCalendar = async (index, cal) => {
		let weeklyCalendar = this.state.weeklyCalendar
		let tempActiveSchool = this.state.activeSchool
		weeklyCalendar[index] = cal
		let returnData = WeeklyCalendarUtil.calculateTotalPeriods(cal);
		let displayingString = WeeklyCalendarUtil.calculateNumberOfDays(cal);
		weeklyCalendar[index].workingDays = displayingString
		weeklyCalendar[index].totalPeriods = returnData.totalPeriods
		weeklyCalendar[index].startHourSlot = returnData.startHourSlot
		weeklyCalendar[index].lastHourSlot = returnData.lastHourSlot
		let calendarData = getTimeTableSlots(cal);
		await this.setState({
			periodFilterGradeDetails: { allGrades: false, gradeLevels: [], grades: [] },
			calendar: cal,
			cal: cal,
			weeklyCalendar: weeklyCalendar,
			calendarData: calendarData,
			displayingString: displayingString,
			totalPeriods: returnData.totalPeriods,
			startHourSlot: returnData.startHourSlot,
			lastHourSlot: returnData.lastHourSlot
		})
		tempActiveSchool.schedule_constraints[this.state.activeScheduleIndex].weeklyCalendar = weeklyCalendar;
		tempActiveSchool.schedule_constraints[this.state.activeScheduleIndex].modifiedDate = new Date();
		//this.props.editSchoolInformation(this.props.userInformation._id, this.state.activeSchool._id, tempActiveSchool)
		//this.props.updateSchoolScheduleConstraints(this.props.userInformation._id, this.state.activeSchool._id, tempActiveSchool,this.state.activeScheduleIndex)
		let result = await saveSchoolScheduleConstraintsConcurrently(this.props.updateSchoolScheduleConstraints,
			this.props.userInformation._id,
			this.state.activeSchool._id,
			tempActiveSchool,
			this.state.activeScheduleIndex,
			this.props.i18n.commonTexts.saveSuccessful);
		if (result.success === true) {
			await this.setState({ activeSchool: result.updatedSchool })
		}
		//	this.calendarTableCancel();
	}

	/**
	 * validating the calendar name. calendar name should be unique
	 */

	calendarNameValidation = (calendar, weeklyCal) => {
		const i18n = this.props.i18n
		let nameFlag = true;
		if (weeklyCal.length > 0) {
			let calendarNamePresent = lodashUtil.find(weeklyCal, ["calendarName", calendar.calendarName]);
			if (calendarNamePresent !== undefined) {
				nameFlag = false;
				toast(i18n.calendar.uniqueCalendarName);
			}
		}
		return nameFlag;
	}

	// SAVE CALENDAR TABLE
	calendarTableSave = async () => {
		let calendar = this.state.calendar
		let returnData = WeeklyCalendarUtil.calculateTotalPeriods(calendar);
		let displayingString = WeeklyCalendarUtil.calculateNumberOfDays(calendar);
		calendar.workingDays = displayingString
		calendar.totalPeriods = returnData.totalPeriods
		calendar.startHourSlot = returnData.startHourSlot
		calendar.lastHourSlot = returnData.lastHourSlot
		let tempActiveSchool = this.state.activeSchool
		let activeScheduleIndex = this.state.activeScheduleIndex
		if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[activeScheduleIndex])) {
			let schedule_constraint = this.props.activeSchool.schedule_constraints[activeScheduleIndex]
			schedule_constraint.weeklyCalendar[0] = calendar
			tempActiveSchool.schedule_constraints[activeScheduleIndex] = schedule_constraint
		} else {
			tempActiveSchool.schedule_constraints[activeScheduleIndex].weeklyCalendar[0] = calendar
		}
		tempActiveSchool.schedule_constraints[activeScheduleIndex].modifiedDate = new Date();

		//await this.props.editSchoolInformation(this.props.userInformation._id, this.state.activeSchool._id, tempActiveSchool)
		let result = await saveSchoolScheduleConstraintsConcurrently(this.props.updateSchoolScheduleConstraints,
			this.props.userInformation._id,
			this.state.activeSchool._id,
			tempActiveSchool,
			activeScheduleIndex,
			this.props.i18n.commonTexts.saveSuccessful);
		if (result.success === true) {
			await this.setState({ activeSchool: result.updatedSchool })
		}
		//this.calendarTableCancel();
		this.setState({
			displayingString: displayingString,
			totalPeriods: returnData.totalPeriods,
			startHourSlot: returnData.startHourSlot,
			lastHourSlot: returnData.lastHourSlot
		})
	};

	// SAVE WEEKLY CALENDAR "periodsDetials" DIALOG
	onClickOfSavePeriod = (cal) => {
		this.validateAndSavePeriod(cal)
	};
	componentWillMount() {
		// This is to clear the weeklyCalendar objects when it saves as null. Need to fix this yet.

		let calendarData = getTimeTableSlots(this.state.calendar)
		this.setState({
			calendarData: calendarData
		})
		if (this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar.length > 0) {
			this.onClickOfEditCalendar()
		}
		else{
			this.addNewCalendar()
			//this.onClickOfEditCalendar()
		}
	}
	validateAndSavePeriod(cal) {
		let calendar = {
			periodsDetails: []
		}
		const i18n = this.props.i18n
		let periodsDetails = JSON.parse(JSON.stringify(cal.periodsDetails));
		let validationFlag = false;
		let timeValidationNotInRange = false;
		let overallValidation = true;
		let periodDetail = {};
		let startTime = this.state.startTime;
		//let startTimeStr = this.state.startTimeStr // commenthing as this is not getting updated in state and is always first period
		let startTimeStr = WeeklyCalendarUtil.getHourMinStr(startTime)
		let endTime = this.state.endTime;
		//let endTimeStr = this.state.endTimeStr // commenthing as this is not getting updated in state and is always first period
		let endTimeStr = WeeklyCalendarUtil.getHourMinStr(endTime)
		let repeatDays = this.state.repeatDays;
		let durationValidation = false;
		let startTimeHour = startTimeStr.split(":")[0];
		let endTimeHour = endTimeStr.split(":")[0];
		/* if (startTimeHour < 6) {
			toast(i18n.calendar.startingTimeValidationForMorning);
			timeValidationNotInRange = true;
		} else if (startTimeHour > 19) {
			toast(i18n.calendar.startingTimeValidationForEvening);
			timeValidationNotInRange = true;
		} else if (endTimeHour > 19) {
			toast(i18n.calendar.endingTimeValidation);
			timeValidationNotInRange = true;
		} */

		if (this.state.radioButtonValue === "break") {
			if (this.state.duration < 5 || this.state.duration > 60) {
				toast(i18n.calendar.breakDurationErrorMsg)
				durationValidation = true;
			}
		} else {
			if (this.state.duration < 15 || this.state.duration > 240) {
				toast(i18n.calendar.periodOrLunchDurationErrorMsg)
				durationValidation = true;
			}
		}

		if (timeValidationNotInRange === false && durationValidation === false) {
			if (this.state.edit === false) {
				calendar = JSON.parse(JSON.stringify(this.state.calendar));
			}
			else {
				calendar = JSON.parse(JSON.stringify(this.state.cal));
			}
			// JSON.stringify ->  convert the whole object into a string 
			//  JSON.parse -> gives a new JSON object off the parameter (string) that we pass.
			if (this.state.editPeriod == true) {
				/**
				 * startTime and endTime is either object (time stamp) or number in milliseconds so we are checking that to convert it to milliseconds   
				 */
				if (typeof startTime == "number") {
					periodDetail.startTime = this.state.startTime
					periodDetail.startTime_str = startTimeStr;
				} else {
					periodDetail.startTime = this.state.startTime.getTime();
					periodDetail.startTime_str = startTimeStr;
					startTime = this.state.startTime.getTime();
					startTimeStr = startTimeStr;
				}

				if (typeof endTime == "number") {
					periodDetail.endTime = this.state.endTime;
					periodDetail.endTime_str = endTimeStr;
				} else {
					periodDetail.endTime = this.state.endTime.getTime();
					periodDetail.endTime_str = endTimeStr;
					endTime = this.state.endTime.getTime();
					endTimeStr = endTimeStr;
				}
			}
			else {
				if (typeof startTime == "number") {
					periodDetail.startTime = this.state.startTime
					periodDetail.startTime_str = startTimeStr;
				} else {
					periodDetail.startTime = this.state.startTime.getTime();
					periodDetail.startTime_str = startTimeStr;
					startTime = this.state.startTime.getTime();
					startTimeStr = WeeklyCalendarUtil.getHourMinStr(startTime);
				}

				if (typeof endTime == "number") {
					periodDetail.endTime = this.state.endTime;
					periodDetail.endTime_str = endTimeStr;
				} else {
					periodDetail.endTime = this.state.endTime.getTime();
					periodDetail.endTime_str = endTimeStr;
					endTime = this.state.endTime.getTime();
					endTimeStr = WeeklyCalendarUtil.getHourMinStr(endTime);
				}
				periodDetail.startTime = startTime;
				periodDetail.endTime = endTime;
				periodDetail.startTime_str = startTimeStr;
				periodDetail.endTime_str = endTimeStr;
			}
			periodDetail.duration = this.state.duration;
			periodDetail.typeOfPeriod = this.state.radioButtonValue;
			if (this.state.radioButtonValue != "period") {
				periodDetail.gradeDetails = this.state.gradeDetailsInWeeklyCal
			} else {
				periodDetail.gradeDetails = this.state.gradeDetailsInPeriod;
			}

			//checking if there are any repeate days selected
			if (this.state.repeatDays.length === 0) {
				toast(i18n.calendar.repeatedDaysEmpty);
				validationFlag = true;
			}
			// ****CREATING THE OBJECT****
			for (let a = 0; a < repeatDays.length; a++) {
				let dayNumber = Number(repeatDays[a])
				let dayObject = {};

				//removing if the object is already there and then saving the new object.
				if (this.state.editPeriod === true) {
					let periodToBeRemoved = lodashUtil.find(periodsDetails, ["dayNumber", dayNumber]);
					if (periodToBeRemoved !== undefined) {
						let startTimeConverted = this.state.previousStartTime
						let periodIndex = lodashUtil.findIndex(periodToBeRemoved.periods, ["startTime", startTimeConverted.getTime()])
						if (periodIndex != -1) {
							periodToBeRemoved.periods.splice(periodIndex, 1)
							if (periodToBeRemoved.periods.length === 0) {
								let periodObjIndex = lodashUtil.findIndex(periodsDetails, ["dayNumber", dayNumber.toString()])
								if (periodObjIndex != -1) {
									periodsDetails.splice(periodObjIndex, 1);
								}
							}
						}
					}
				}

				// if there is already an object for that particular day then have to push it to the same object
				dayObject = lodashUtil.find(periodsDetails, ["dayNumber", dayNumber])
				if (dayObject !== undefined) {
					dayObject.periods.push(periodDetail);
					dayObject.periods = lodashUtil.orderBy(dayObject.periods, ["startTime"], ["asc"]);
					validationFlag = this.validationForPeriods(dayObject.periods, startTime)

				}
				//if weekday object is not present then need to create one and then push the object data 
				else {
					dayObject = {
						dayNumber: undefined,
						periods: [],
						breakCount: undefined,
						lunchCount: undefined,
					};
					dayObject.dayNumber = dayNumber;
					dayObject.periods.push(periodDetail);
					let periodObj = WeeklyCalendarUtil.periodNaming(dayObject.periods);
					dayObject.periods = JSON.parse(JSON.stringify(periodObj.updatedPeriodName));
					dayObject.breakCount = periodObj.breakCount;
					dayObject.lunchCount = periodObj.lunchCount;
					periodsDetails.push(dayObject);
				}

				if (validationFlag === false) {
					let periodObj = WeeklyCalendarUtil.periodNaming(dayObject.periods);
					dayObject.periods = JSON.parse(JSON.stringify(periodObj.updatedPeriodName));
					dayObject.breakCount = periodObj.breakCount;
					dayObject.lunchCount = periodObj.lunchCount;
					periodsDetails = lodashUtil.orderBy(periodsDetails, ["dayNumber"], ["asc"]);
				} else {
					overallValidation = false;
					break;
				}
			}
			//SORTING OF THE PERIODS DETAILS ACCORDING TO THE DAY NUMBER

			if (overallValidation === true) {
				calendar.periodsDetails = JSON.parse(JSON.stringify(periodsDetails))
				if (this.state.periodFilterGradeDetails !== undefined) {
					this.filteringPeriods(this.state.periodFilterGradeDetails, calendar)
				} else {
					let calendarData = getTimeTableSlots(calendar)
					this.setState({
						calendarData: calendarData
					})
				}

				this.setState({
					calendar: calendar,
					cal: calendar,
					startTime: this.state.endTime,
					duration: this.state.duration,

					editPeriod: false,
					endTime: addMinutes(this.state.endTime, this.state.duration),
					startTimeStr: this.state.startTimeStr,
					endTimeStr: this.state.endTimeStr
				});
				this.weeklyCalCancel();
			}
		}
	}

	// this method takes in the sorted periods array and the startTime of the new object which is being saved.
	validationForPeriods = (sortedPeriod, startTime) => {
		const i18n = this.props.i18n
		let validationFlag = false;
		let validatePeriod = sortedPeriod;
		if (validatePeriod.length > 1) {
			let duplicatePeriod = lodashUtil.filter(validatePeriod, ['startTime', startTime])
			if (duplicatePeriod.length > 1) {
				toast(i18n.calendar.duplicatePeriod);
				validationFlag = true;
			}
			else {
				let index = lodashUtil.findIndex(validatePeriod, { 'startTime': startTime })

				//this is the first element of the array
				if (index === 0) {
					if (validatePeriod[index].endTime > validatePeriod[index + 1].startTime) {
						let errorMessage_endTimeOverLapping = StringReplacer.getFormatedMessage(i18n.calendar.endTimeOverLapping,
							{
								periodName: validatePeriod[index + 1].periodName
							})
						toast(errorMessage_endTimeOverLapping)
						validationFlag = true;
					}
				}
				//this is the last element of the array
				else if ((index + 1) === validatePeriod.length) {
					if (validatePeriod[index - 1].endTime > validatePeriod[index].startTime) {
						let errorMessage_startTimeOverLapping = StringReplacer.getFormatedMessage(i18n.calendar.startTimeOverLapping,
							{
								periodName: validatePeriod[index - 1].periodName
							})
						toast(errorMessage_startTimeOverLapping)
						validationFlag = true;
					}
				}
				//the new object sits anywhere other than first or last
				else {
					if (validatePeriod[index].endTime > validatePeriod[index + 1].startTime) {
						let errorMessage_endTimeOverLapping = StringReplacer.getFormatedMessage(i18n.calendar.endTimeOverLapping,
							{
								periodName: validatePeriod[index + 1].periodName
							})
						toast(errorMessage_endTimeOverLapping)
						validationFlag = true;
					}
					else if (validatePeriod[index - 1].endTime > validatePeriod[index].startTime) {
						let errorMessage_startTimeOverLapping = StringReplacer.getFormatedMessage(i18n.calendar.startTimeOverLapping,
							{
								periodName: validatePeriod[index - 1].periodName
							})
						toast(errorMessage_startTimeOverLapping)
						validationFlag = true;
					}
				}
			}
		}
		return validationFlag;
	}


	onClickOfEditCalendar = (cal, index) => {
		cal = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar[0]
		let calendarGradeDetails = JSON.parse(JSON.stringify(cal.gradeDetails));
		let gradeDetailsObj;
		gradeDetailsObj = gradePickerUtil.changingSubsetGradeDetail(calendarGradeDetails, this.props)
		WeeklyCalendarUtil.populatePeriodTimeStrs(cal);
		let calendarData = getTimeTableSlots(cal);
		this.setState({
			showAddNewCalendar: true,
			showCard: false,
			cal: cal,
			calIndex: 0,
			edit: true,
			calendarData: calendarData,
			gradeDetailsInWeeklyCal: calendarGradeDetails,
			gradeDetailsInPeriod: gradeDetailsObj,
		})
	}

	getHourMinStr(adate) {
		return WeeklyCalendarUtil.getHourMinStr(adate);
	}

	onEditOfPeriod = (period, index, dayObj) => {
		let periodsDetails
		let gradeDetailsInWeeklyCal
		let showGradeDropDownInPeriod;
		if (this.state.edit === true) {
			periodsDetails = this.state.cal.periodsDetails
			gradeDetailsInWeeklyCal = this.state.cal.gradeDetails
		} else {
			periodsDetails = this.state.calendar.periodsDetails
			gradeDetailsInWeeklyCal = this.state.calendar.gradeDetails
		}
		let periodDetail = period
		let startTime = new Date(WeeklyCalendarUtil.getDayForHourAndMin(periodDetail.startTime_str).getTime())
		let startTimeStr = this.getHourMinStr(startTime);
		let endTime = new Date(WeeklyCalendarUtil.getDayForHourAndMin(periodDetail.endTime_str).getTime())
		let endTimeStr = this.getHourMinStr(endTime);
		periodDetail.startTime_str = startTimeStr;
		periodDetail.endTime_str = endTimeStr;
		let duration = periodDetail.duration;
		let repeatDays = [];
		repeatDays.push(dayObj.dayNumber.toString());
		let radioButtonValue = periodDetail.typeOfPeriod
		this.radioButtonNote(radioButtonValue);
		let gradeDetails = periodDetail.gradeDetails
		let periodName = periodDetail.periodName
		if (radioButtonValue === "period") {
			showGradeDropDownInPeriod = true;
		} else {
			showGradeDropDownInPeriod = false;
		}
		this.setState({
			showCalendarTable: true,
			startTime: startTime,
			startTimeStr: startTimeStr,
			previousStartTime: startTime,
			endTime: endTime,
			endTimeStr: endTimeStr,
			duration: duration,
			editPeriod: true,
			repeatDays: repeatDays,
			radioButtonValue: radioButtonValue,
			gradeDetails: gradeDetails,
			gradeDetailsInPeriod: gradeDetails,
			gradeDetailsInWeeklyCal: gradeDetailsInWeeklyCal,
			index: index,
			periodName, periodName,
			showGradeDropDownInPeriod: showGradeDropDownInPeriod,
		})
	}


	weeklyCalendarDelete = (calendarObj) => {
		//reference for the calendar object so that the changes made here (deleteing) will be refelected in the calendar.
		let calendar = calendarObj;
		let repeatDays = this.state.repeatDays;
		let startTime = this.state.startTimeStr;
		for (let c = 0; c < repeatDays.length; c++) {
			let dayNumber = Number(repeatDays[c]);
			let periodToBeRemoved = lodashUtil.find(calendar.periodsDetails, ["dayNumber", dayNumber])
			if (periodToBeRemoved !== undefined) {
				let startTimeIndex = lodashUtil.findIndex(periodToBeRemoved.periods, ["startTime_str", startTime])
				if (startTimeIndex != -1) {
					periodToBeRemoved.periods.splice(startTimeIndex, 1)
					if (periodToBeRemoved.periods.length === 0) {
						let periodLengthIsZeroIndex = lodashUtil.findIndex(calendar.periodsDetails, ["dayNumber", dayNumber])
						if (periodLengthIsZeroIndex != -1) {
							calendar.periodsDetails.splice(periodLengthIsZeroIndex, 1);
						}
					}
				}
			}
		}
		for (let d = 0; d < calendar.periodsDetails.length; d++) {
			let dayObj = calendar.periodsDetails[d]
			let periodObj = WeeklyCalendarUtil.periodNaming(dayObj.periods);
			calendar.periodsDetails[d].periods = JSON.parse(JSON.stringify(periodObj.updatedPeriodName));
			calendar.periodsDetails[d].breakCount = periodObj.breakCount;
			calendar.periodsDetails[d].lunchCount = periodObj.lunchCount;
		}
		if (this.state.periodFilterGradeDetails !== undefined) {
			this.filteringPeriods(this.state.periodFilterGradeDetails, calendar)
		} else {
			let calendarData = getTimeTableSlots(calendar)
			this.setState({
				calendarData: calendarData
			})
		}
		this.setState({
			showCalendarTable: false,
			editPeriod: false,
			calendar: calendar
		})

	}
	removeCalendarFromWeeklyCalendar = async (key, weeklyCal) => {

		let tempActiveSchool = this.state.activeSchool
		let activeScheduleIndex = this.state.activeScheduleIndex
		weeklyCal.splice(key, 1)
		this.setState({ weeklyCalendar: weeklyCal })

		tempActiveSchool.schedule_constraints[activeScheduleIndex].weeklyCalendar = weeklyCal
		tempActiveSchool.schedule_constraints[activeScheduleIndex].modifiedDate = new Date();
		//await this.props.editSchoolInformation(this.props.userInformation._id, this.state.activeSchool._id, tempActiveSchool)
		let result = await saveSchoolScheduleConstraintsConcurrently(this.props.updateSchoolScheduleConstraints,
			this.props.userInformation._id,
			this.state.activeSchool._id,
			tempActiveSchool,
			activeScheduleIndex,
			this.props.i18n.commonTexts.saveSuccessful);
		if (result.success === true) {
			await this.setState({ activeSchool: result.updatedSchool })
		}
		return (<AddNewCalendar />)
	}

	filteringPeriods = (filterGradeDetail, calendar) => {
		let calendarObj = JSON.parse(JSON.stringify(calendar))

		let filteringGradeDetail = gradePickerUtil.convertingGradeDetailsToLowestFormat(filterGradeDetail, this.props);
		for (let x = 0; x < calendarObj.periodsDetails.length; x++) {
			let dayObject = calendarObj.periodsDetails[x];
			for (let y = 0; y < dayObject.periods.length; y++) {
				let periodObject = dayObject.periods[y];
				let periodGradeDetail = gradePickerUtil.convertingGradeDetailsToLowestFormat(periodObject.gradeDetails, this.props);
				let filteredGradeExists = lodashUtil.difference(filteringGradeDetail, periodGradeDetail);
				if (filteredGradeExists.length !== 0) {
					dayObject.periods.splice(y, 1);
					y -= 1;
				}
			}
		}
		let calendarData = getTimeTableSlots(calendarObj)
		this.setState({
			calendarData: calendarData
		})
	}

	render() {
		if (this.props.updateSchoolinformationInProgress == true) {
			return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' >
				<img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
		}
		return (

			<React.Fragment>
				<MuiGrid container xs={12} style={{ width: '80vw' }} align='center'>
					<AddNewCalendar
						{...this.props}
						{...this.state}
						weeklyCalendarSave={this.weeklyCalendarSave}
						handleTimeChange={this.handleTimeChange}
						handleDurationChange={this.handleDurationChange}
						toggleGradPicker={this.toggleGradPicker}
						removeCalendarFromWeeklyCalendar={this.removeCalendarFromWeeklyCalendar}
						addNewCalendar={this.addNewCalendar}
						weeklyCalCancel={this.weeklyCalCancel}
						handleChangeForRadioButton={this.handleChangeForRadioButton}
						onClickOfDays={this.onClickOfDays}
						onClickOfCreate={this.onClickOfCreate}
						calendarTableCancel={this.calendarTableCancel}
						onClickOfSavePeriod={this.onClickOfSavePeriod}
						calendarName={this.calendarName}
						gradePickerSaveInCalendar={this.gradePickerSaveInCalendar}
						calendarTableSave={this.calendarTableSave}
						gradePickerSaveInPeriods={this.gradePickerSaveInPeriods}
						onClickOfEditCalendar={this.onClickOfEditCalendar}
						calculateNumberOfDays={this.calculateNumberOfDays}
						saveEditCalendar={this.saveEditCalendar}
						onEditOfPeriod={this.onEditOfPeriod}
						onClickOfCreateOfPerod={this.onClickOfCreateOfPerod}
						weeklyCalendarDelete={this.weeklyCalendarDelete}
						weeklyCalDelete={this.weeklyCalDelete}
						toggleGradPickerWithACheck={this.toggleGradPickerWithACheck}
						toggleGradPickerForPeriodFiltering={this.toggleGradPickerForPeriodFiltering}
						gradePickerSaveForPeriodFiltering={this.gradePickerSaveForPeriodFiltering}
					/>
				</MuiGrid>
			</React.Fragment>
		)
	}
}
const mapDispatchToProps = (dispatch) => ({
	editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
	updateSchoolScheduleConstraints: (ownerId, schoolId, school, scheduleConstraintsIndex) => dispatch(SchoolInformationActions.updateSchoolScheduleConstraints(ownerId, schoolId, school, scheduleConstraintsIndex))
});
const mapStateToProps = (state) => ({
	activeSchool: state.schoolInformation.activeSchool,
	activeScheduleIndex: state.schoolInformation.activeScheduleIndex,
	userInformation: state.userProfile.userInformation,
	// i18n: state.i18nMessages.i18n,
});
export default connect(mapStateToProps, mapDispatchToProps)(WeeklyCalendarContainer);
